import { render, staticRenderFns } from "./carpsaleHistoryChatPdfPage.vue?vue&type=template&id=4704ec30&"
import script from "./carpsaleHistoryChatPdfPage.vue?vue&type=script&lang=ts&"
export * from "./carpsaleHistoryChatPdfPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports